import { useNavigate } from 'react-router-dom'

interface ClickableRowProps {
  to: string
  className?: string
  children: React.ReactNode
  'aria-label'?: string
}

export default function ClickableRow({ to, className, children, 'aria-label': ariaLabel }: ClickableRowProps) {
  const navigate = useNavigate()

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={() => navigate(to)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          navigate(to)
        }
      }}
      className={`flex cursor-pointer items-center justify-between rounded-lg border px-4 py-3 transition-colors focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:outline-hidden ${className ?? ''}`}
    >
      {children}
    </div>
  )
}
